export default {
      id: "register-a-complaint-usage",
      viewBox: "0 0 24 32",
      url: __webpack_public_path__ + "sprite.svg#register-a-complaint",
      toString: function () {
        return this.url;
      }
    }